import { Memory } from '../types'

export function exportMemoriesAsJSON(memories: Memory[], filename: string = 'memories.json') {
  const dataStr = JSON.stringify(memories, null, 2)
  const dataBlob = new Blob([dataStr], { type: 'application/json' })
  const url = URL.createObjectURL(dataBlob)
  
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

export function exportMemoriesAsCSV(memories: Memory[], filename: string = 'memories.csv') {
  // CSV headers
  const headers = ['ID', 'Content', 'Category', 'Source', 'Importance', 'Tags', 'Created At']
  
  // CSV rows
  const rows = memories.map(memory => [
    memory.id,
    `"${memory.content.replace(/"/g, '""')}"`, // Escape quotes
    memory.category,
    memory.source,
    memory.importance_score,
    memory.tags?.join('; ') || '',
    new Date(memory.created_at).toLocaleString(),
  ])
  
  // Combine headers and rows
  const csvContent = [
    headers.join(','),
    ...rows.map(row => row.join(',')),
  ].join('\n')
  
  const dataBlob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(dataBlob)
  
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}
